import BreadCrumbComp from "../../../components/breadCrumb";
import { useState } from "react";
import { icons } from "../../../constants";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import VerificationModal from "../../../components/modals/verificationModal";
import LaddaButton from "../../../components/buttons/laddaButton";
import { useSelector } from "react-redux";
import { canManageNationalSuppliers } from "../../../constants/supplierRoles";
import {
  addOrUpdateNationalSuppliersProduct,
  callApiAsync,
  deleteNationalSupplier,
  deleteSuppliersProduct,
  getNationalSuppliers,
  getProductsBySupplier
} from "../../../services/apiService";
import ToastNotification from "../../../components/toastNotification";
import ExpandableTable from "../../../components/tables/expandableTable";
import IconButtonTable from "../../../components/buttons/iconButton";
import CreateProductModal from "../createProductModal";
import { formatCustomDate } from "../../../services/dateService";
import { supplierType } from "../../../constants/enums";

const NationalSuppliers = () => {
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [openVerification, setOpenVerification] = useState(false);
  const [openProductVerification, setOpenProductVerification] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [deleteCount, setDeleteCount] = useState(0);

  const [toastConfig, setToastConfig] = useState({
    severity: "success",
    summary: "",
    detail: ""
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [parentSelected, setParentSelected] = useState({});
  const [childSelected, setChildSelected] = useState({});

  const navigate = useNavigate();
  const userData = useSelector((state) => state.userData.userData);

  const isSupplierManagment = canManageNationalSuppliers(userData.roleList);

  const handleCloseModal = () => {
    setModalOpen(false);
    setParentSelected({});
    setChildSelected({});
  };

  const columns = [
    { field: "supplier_name", header: "Nombre del Proveedor" },
    { field: "nit_rut", header: "NIT" },
    { field: "address", header: "Dirección Principal" },
    { field: "product_name", header: "Producto" },
    { field: "invima_register", header: "Registro Invima" },
    { field: "expire_date", header: "Fecha de Vencimiento" }
  ];

  const actionButtons = (rowData, type) => {
    if (type === "parent") {
      return (
        <div className="HContainer p-gap-2">
          {isSupplierManagment && (
            <IconButtonTable
              icon={icons.addPlus}
              background="#6A6AD80D"
              iconSize="18px"
              onClick={(row) => {
                setModalOpen(true);
                setParentSelected(row);
              }}
              rowData={rowData}
              isLoading={(row) => row.loading === true}
              hideCondition={(row) => row.hidden}
              tootip="Agregar Producto/Dispositivo"
            />
          )}
          <IconButtonTable
            icon={icons.linkBlue}
            background="#6A6AD80D"
            iconSize="16px"
            onClick={(row) => {
              if (row.financial_statement_url) {
                window.open(row.financial_statement_url, "_blank");
              } else {
                console.warn("No hay URL para abrir.");
              }
            }}
            rowData={rowData}
            isLoading={(row) => row.loading === true}
            hideCondition={(row) => row.hidden}
            tootip="Estado Financiero"
          />
          <IconButtonTable
            icon={!isSupplierManagment ? icons.eye : icons.editBlue}
            background="#6A6AD80D"
            iconSize="18px"
            onClick={(row) => {
              navigate("/suppliers/suppliers_national/create_new", {
                state: { data: row }
              });
            }}
            rowData={rowData}
            isLoading={(row) => row.loading === true}
            hideCondition={(row) => row.hidden}
            tootip={!isSupplierManagment ? "Detalles" : "Editar"}
          />
          {isSupplierManagment && (
            <IconButtonTable
              icon={icons.redTrash}
              background="#6A6AD80D"
              iconSize="18px"
              onClick={(row) => {
                setParentSelected(row);
                handleRemove(row);
              }}
              rowData={rowData}
              isLoading={(row) => row.loading === true}
              hideCondition={(row) => row.hidden}
              tootip="Eliminar"
            />
          )}
        </div>
      );
    }

    if (type === "child") {
      return (
        <div className="HContainer j-end">
          <IconButtonTable
            icon={!isSupplierManagment ? icons.eye : icons.editBlue}
            background="#6A6AD80D"
            iconSize="18px"
            onClick={(row) => {
              setModalOpen(true);
              setChildSelected(row);
            }}
            rowData={rowData}
            isLoading={(row) => row.loading === true}
            hideCondition={(row) => row.hidden}
            tootip={!isSupplierManagment ? "Detalles" : "Editar"}
          />
          {isSupplierManagment && (
            <IconButtonTable
              icon={icons.redTrash}
              background="#6A6AD80D"
              iconSize="18px"
              onClick={(row) => {
                setChildSelected(row);
                handleProductRemove();
              }}
              rowData={rowData}
              isLoading={(row) => row.loading === true}
              hideCondition={(row) => row.hidden}
              tootip="Eliminar"
            />
          )}
        </div>
      );
    }

    return null;
  };

  const getTableData = async () => {
    await callApiAsync(
      () => getNationalSuppliers(),
      (data) => {
        setTableData(data);
        setFilteredTableData([]);
        setSelectedData(null);
      }
    );
    return;
  };

  const handleRemove = (data) => {
    getProductsBySupplierNumber(data);
    setOpenVerification(true);
  };

  const handleProductRemove = () => {
    setOpenProductVerification(true);
  };

  const getProductsBySupplierNumber = async (data) => {
    await callApiAsync(
      () => getProductsBySupplier(data.id, supplierType.national),
      (data) => {
        setDeleteCount(data.length);
      }
    );
    return;
  };

  const handleRemoveConfirmed = async () => {
    await callApiAsync(
      () => deleteNationalSupplier({ id: parentSelected.id }),
      (data) => {
        getTableData();
        setSelectedData(null);
        setOpenVerification(false);
        setToastConfig({
          severity: "success",
          summary: "Acción realizada",
          detail: "Se elimino el proveedor con éxito."
        });
        setShowToast(true);
      }
    );
  };

  const handleRemoveProductConfirmed = async () => {
    await callApiAsync(
      () => deleteSuppliersProduct({ id: childSelected.childId }),
      () => {
        getTableData();
        setChildSelected({});
        setOpenProductVerification(false);
        setToastConfig({
          severity: "success",
          summary: "Acción realizada",
          detail: "Se elimino el producto con éxito."
        });
        setShowToast(true);
      }
    );
  };

  const handleCreateProduct = async (data) => {
    await callApiAsync(
      () => addOrUpdateNationalSuppliersProduct(data),
      () => {
        getTableData();
      }
    );
  };

  useEffect(() => {
    getTableData();
  }, []);

  return (
    <div>
      <BreadCrumbComp />

      <div className="searchTitle  HContainer j-space-between align-center">
        <h1>PROVEEDOR FARMACÉUTICO NACIONAL</h1>

        {isSupplierManagment && (
          <LaddaButton
            variant="contained"
            height={"32px"}
            onClick={() => {
              navigate("/suppliers/suppliers_national/create_new", {
                state: { data: { id: 0 } }
              });
            }}
          >
            <div className="IHContainer align-center">
              <img
                className="btn-icon"
                src={icons.plusIcon}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
              <p className="button_text">
                Crear Proveedor Farmacéutico Nacional
              </p>
            </div>
          </LaddaButton>
        )}
      </div>

      <div>
        <ExpandableTable
          data={tableData}
          columns={columns}
          globalFilterFields={[
            "supplier_name",
            "nit_rut",
            "address",
            "product_name",
            "invima_register"
          ]}
          actionButtons={actionButtons}
        />
      </div>
      <CreateProductModal
        open={modalOpen}
        handleClose={handleCloseModal}
        onSubmit={(formData) => {
          handleCreateProduct(formData);
        }}
        initialData={childSelected}
        parentSelected={parentSelected}
        canManage={isSupplierManagment}
      />
      <VerificationModal
        open={openVerification}
        handleClose={() => {
          setOpenVerification(false);
          setParentSelected({});
        }}
        alertText={`¿Estás seguro de eliminar este proveedor? ${
          deleteCount > 0
            ? `Este proveedor tiene ${deleteCount} productos asociados.`
            : ""
        }`}
        onConfirm={handleRemoveConfirmed}
      />
      <VerificationModal
        open={openProductVerification}
        handleClose={() => {
          setOpenProductVerification(false);
          setChildSelected({});
        }}
        alertText="¿Estás seguro de eliminar este producto?"
        onConfirm={handleRemoveProductConfirmed}
      />
      <ToastNotification
        severity={toastConfig.severity}
        summary={toastConfig.summary}
        detail={toastConfig.detail}
        showToast={showToast}
        setShowToast={setShowToast}
        position="top-right"
      />
    </div>
  );
};

export default NationalSuppliers;
